import { formatDate } from 'date-fns'
import { restApiKey, table, viewId } from '../../../../_constants/Code'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { errorLog } from '../../../../common/logger/Logger'
import { getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { httpGet } from '../../../../services/api/AmplifyApi'
import { filterDataCreateTask } from '../../employeeCountInfo/extra/dataParsers'
import { fetchFiscalYearDateList } from '../../employeeCountInfo/extra/fiscalYearUtils'
import { fetchtDataCreateTask } from '../../employeeCountInfo/extra/services'
import { getPeriodYm, formatDateToString, getFiscalPeriodRange } from './dateUtils'

const logError = (error) => {
  if (window.debug_ || true) console.error(error)
}

// 画面情報取得API
export async function fetchLegalDisclosure(props, fiscalYearStartDate, fiscalYearEndDate) {
  try {
    const init = {
      headers: {},
      queryStringParameters: {
        period_start: formatDate(fiscalYearStartDate, 'yyyy-MM-dd'),
        period_end: formatDate(fiscalYearEndDate, 'yyyy-MM-dd')
      }
    }
    const legalDisclosureData = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getLegalDisclosure(props.corporationNumber),
      init
    )

    if (!legalDisclosureData) throw new Error('データがありません')

    return legalDisclosureData
  } catch (error) {
    logError(error)

    return []
  }
}

/**
 * マスター情報取得関数
 *
 * @returns {Promise<Object>} 取得したマスター情報
 */
export const fetchMasterData = async (props) => {
  try {
    const masterData = await getDynamoDB(
      table.Master,
      null,
      props.corporationNumber,
      { CorporationNumber: props.corporationNumber, MasterId: viewId.statutoryDisclosure },
      null
    )
    return masterData[0]
  } catch (error) {
    errorLog('E000001', props.userId, viewId.statutoryDisclosure, 'fetchMasterData', error)
  }
}

/** 年度リスト取得関数 S3内のファイル名から年度リストを作成する */
export const fetchFiscalYearList = async (currentYear, props) => {
  try {
    const { corporationNumber, accPeriod } = props
    const dataCreateTask = await fetchtDataCreateTask(corporationNumber, corporationNumber)
    const annualTask = filterDataCreateTask(dataCreateTask, accPeriod)
    const fiscalYearDataList = fetchFiscalYearDateList(annualTask, accPeriod)

    return fiscalYearDataList.map((e) => e.fiscalYear)
  } catch (error) {
    errorLog('E000001', props.userId, viewId.statutoryDisclosure, 'fetchFiscalYearList', error)
    return []
  }
}

/**
 * @function fetchCodeMaster Categoryからコンフィグを取得
 * @param {string} corporationNumber
 * @param {string} category
 * @returns {Promise<GenericTaskType>}
 */
export async function fetchCodeMaster(corporationNumber, category) {
  const configs = await fetchCodeMasterList(corporationNumber)
  const config = configs.find((e) => e.Category === category)
  return config
}

/**
 * 指定されたS3バケットからコードマスターのJSONデータを取得する関数
 *
 * @param {string} corporationNumber - 法人番号
 * @returns {Promise<(string | number)[][]>} 雇用区分マスターが格納されたCSVデータの2次元配列を返す。
 */
export async function fetchCodeMasterList(corporationNumber) {
  try {
    const objectKeyName = PathInfoList.Folder.configFolder + PathInfoList.Objectkeyname.codeMaster
    const init = {
      headers: {},
      queryStringParameters: {
        object_key_name: objectKeyName
      }
    }
    const codeMasterConfig = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getJsonFromCommonBucket(corporationNumber),
      init
    )

    if (!codeMasterConfig) throw new Error('データがありません')

    return codeMasterConfig.data
  } catch (error) {
    logError(error)

    return []
  }
}

/**
 * DynamoDBから年度ごとの法人設定を取得
 *
 * @param {string} corporationNumber - 法人番号
 * @returns {Promise<(string | number)[][]>} 雇用区分マスターが格納されたCSVデータの2次元配列を返す。
 */
export async function fetchCompanyConfig(corporationNumber, key) {
  try {
    const companyConfig = await getDynamoDB(table.CompanyConfig, null, corporationNumber, {
      CorporationNumber: corporationNumber,
      Key: key
    })

    if (!companyConfig || companyConfig.length === 0) {
      // レコードがない場合は空の配列を返す
      return []
    }

    return companyConfig[0].Config
  } catch (error) {
    console.error(error)
    errorLog('E000001', userId, viewId.statutoryDisclosure, 'fetchCompanyConfig', error)
  }
}

/**
 * 画面に登録データを反映するためのデータリスト作成
 *
 * @param {object} props - コンポーネントのprops
 * @param {string} selectedFiscalYear - 選択中の年度
 * @returns {object} 画面表示用のデータオブジェクト
 */
export const getDataList = (props, selectedFiscalYear) => {
  const periodLabel = getPeriodYm(props.accPeriod, selectedFiscalYear)
  const { maxDate } = getFiscalPeriodRange(periodLabel)
  const fiscalYearMonthStr = formatDateToString(maxDate)

  return {
    法人番号: props.corporationNumber,
    企業名: props.corporationName,
    年度: selectedFiscalYear,
    決算年月: fiscalYearMonthStr
  }
}
